function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePlayPlus = function SvgImagePlayPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    style: {
      fillOpacity: 1,
      strokeOpacity: 1
    },
    transform: "matrix(.79791 0 0 .8503 -5.861 -3.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m0 0 22.652 15.997L0 32Z",
    style: {
      fillOpacity: 1,
      strokeOpacity: 1
    },
    transform: "translate(8.921 6)scale(.625)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2",
    style: {
      fillOpacity: 1,
      strokeOpacity: 1
    },
    transform: "matrix(.58184 0 0 .58184 11.69 .69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-8",
    d: "M12.127 0h7.745v12.128H32v7.745H19.872v12.126h-7.745V19.873H0v-7.745h12.127z",
    style: {
      fillOpacity: 1,
      strokeOpacity: 1
    },
    transform: "translate(6 6)scale(.625)"
  })));
};
export { SvgImagePlayPlus as ReactComponent };
export default __webpack_public_path__ + "assets/ImagePlayPlus.fc9b9dbb2ad070b3a8c5643c8bf5eb84.svg";